import { render } from "./CampaignManageListForm.vue?vue&type=template&id=5c0ef4bc&lang=true"
import script from "./CampaignManageListForm.vue?vue&type=script&lang=js"
export * from "./CampaignManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__